<template>
	<div id="panel_solutions" class="panel solutions">
		<div class="container">
			<div class="panel_header">
				<div class="row align-items-end">
					<div class="col-12">
						<h2>Уникальные образовательные решения для компаний</h2>
					</div>
				</div>
				<!-- <nuxt-link class="panel_control" to="#"></nuxt-link> -->
			</div>

			<div class="row">
				<div class="col-12 col-lg-6">
					<div class="solutions_overview">
						<div class="title">
							В СКОЛКОВО разработаны уникальные образовательные решения, способствующие реализации стратегических целей бизнеса через развитие потенциала сотрудников компании.
						</div>
						<p class="description">
							Наша миссия – глубоко понять задачи, стоящие перед бизнесом наших клиентов. И предложить такой набор модулей и методов, которые наилучшим образом отвечают стоящим перед компанией задачам. Поэтому каждая программа разрабатывается индивидуально.
						</p>
					</div>
				</div>
				<div class="col-12 col-md-4 col-lg-2">
					<div class="solutions_item">
						<div class="digit">
							<b-img-lazy src="/svg/FT.svg" alt="" />
						</div>
						<div class="title">
							Рейтинг Financial Times
						</div>
					</div>
				</div>
				<div class="col-12 col-md-4 col-lg-2">
					<div id="solution_companies" class="solutions_item">
						<div class="digit">
							197
						</div>
						<div class="title">
							компаний-клиентов
						</div>
					</div>
				</div>
				<div class="col-12 col-md-4 col-lg-2">
					<div id="solution_students" class="solutions_item">
						<div class="digit">
							27400
						</div>
						<div class="title">
							слушателей программ
						</div>
					</div>
				</div>
			</div>

			<div class="panel_footer">
				<div class="row">
					<div class="col-12">
						<div class="btn-panel">
							<a href="https://corporate.skolkovo.ru/ru/corporate/" class="btn btn-primary">Подобрать корпоративную программу</a>
							<a
								id="solutions_jivosite_top"
								onclick="return jivo_api.open(),!1"
								href="javascript:void(0)"
								class="btn btn-secondary-outer"
								role="button"
							>Чат с консультантом</a>
							<!--<a
								href="javascript:void(0)"
								onclick="ComagicWidget.openSitePhonePanel(); return false;"
								class="btn btn-secondary-outer"
							>Обратный звонок</a>-->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'PanelSolutions',
};
</script>
<style lang="scss" scoped>
    @import '~/assets/styles/components/home/panel-solutions';
</style>
